export default {
  message: 'dude',
  color: '',
  active: false,
};
